import type { ReactNode } from 'react'

interface GlobalSearchTriggerProps {
  onClick: () => void
}

export const GlobalSearchTrigger = ({ onClick }: GlobalSearchTriggerProps): ReactNode => (
  <button
    type="button"
    onClick={onClick}
    className="global-search-trigger inline-flex h-9 w-full cursor-text items-center justify-between gap-4 rounded-md border bg-background px-4 py-2 text-sm text-muted-foreground shadow-sm focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring md:w-64 lg:w-80"
  >
    <span className="hidden lg:inline-flex">Search...</span>
    <span className="inline-flex lg:hidden">Search...</span>
    <kbd className="pointer-events-none hidden h-5 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-[10px] font-medium opacity-100 sm:flex">
      <span className="text-xs">⌘</span>K
    </kbd>
  </button>
)
